var styles = {"location":"index-module_location__vLPWy"};

export { styles as default };
//# sourceMappingURL=index.module.css.js.map
